import { Controller, useFormContext } from "react-hook-form";
import { Options } from "../../PostBooking/OngoingBooking/OngoingBookingFilter/types";
import BMCheckboxSelection from "./BMCheckboxSelection";

type Props = {
  options: Options;
  isVisible: boolean;
  setVisible: (visible: boolean) => void;
  name: string;
  title?: string;
  inputPlaceholder?: string;
  testID?: string;
};

export default function BMCheckboxSelectionRHF(props: Props) {
  const { name } = props;
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <BMCheckboxSelection {...props} value={value} onChange={onChange} />
      )}
    />
  );
}
